import { CardGroup } from '@source-components-react/types';
import { cardEntries } from './card-entries/card-entries';

export const cardGroups: CardGroup[] = [
  { title: 'Cards', cards: [{ title: 'Cards', entries: cardEntries }] },
];
